/* HealthspanX Luminous Field V2: progressive enhancement, scoped, no legacy runtime. */
(()=>{'use strict';
 const root=document.documentElement,themeKey='hsx-theme';
 const sync=(parent=document)=>parent.querySelectorAll('[data-hsx2-theme]').forEach(btn=>{
   const dark=root.dataset.theme==='dark';btn.setAttribute('aria-pressed',String(dark));
   btn.setAttribute('aria-label',dark?'Switch to light mode':'Switch to dark mode');
 });
 function bind(parent=document){
   parent.querySelectorAll('[data-hsx2-theme]').forEach(btn=>{
     if(btn.dataset.hsx2Ready)return;btn.dataset.hsx2Ready='1';
     btn.addEventListener('click',()=>{const next=root.dataset.theme==='dark'?'light':'dark';
       root.dataset.theme=next;if(root.dataset.hsxEditor!=='true'){try{localStorage.setItem(themeKey,next)}catch(e){}}
       sync(document);
     });
   });
   parent.querySelectorAll('[data-hsx2-menu]').forEach(menu=>{
     if(menu.dataset.hsx2Ready)return;menu.dataset.hsx2Ready='1';
     menu.addEventListener('keydown',ev=>{if(ev.key==='Escape'&&menu.open){menu.open=false;menu.querySelector('summary')?.focus()}});
   });sync(parent);
 }
 document.addEventListener('click',ev=>{
   document.querySelectorAll('[data-hsx2-menu][open]').forEach(menu=>{if(!menu.contains(ev.target))menu.open=false});
 });
 document.addEventListener('shopify:section:load',ev=>bind(ev.target));
 document.addEventListener('shopify:section:unload',ev=>ev.target.querySelectorAll('[data-hsx2-menu][open]').forEach(m=>m.open=false));
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>bind(),{once:true});else bind();
})();